"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPageStateKey = void 0;
/**
 * Build the page state key
 *
 * @param pageState Page state
 * @returns Page State Key
 */
const buildPageStateKey = (pageState) => `${new Date(pageState.created_at).getTime()}-${pageState.url}`;
exports.buildPageStateKey = buildPageStateKey;
//# sourceMappingURL=build-page-state-key.js.map